module.exports = __webpack_public_path__ + "static/quiz2_3-d4345071eec3b176970422c1b179dfba.png";